(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gabriela-conversion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bundle = document.querySelector('[data-sv-gabriela-bundle]');
    if (!bundle || bundle.dataset.ready === 'true') return;
    bundle.dataset.ready = 'true';
    const parse = (selector) => { const node = document.querySelector(selector); try { return node ? JSON.parse(node.textContent) : []; } catch (_) { return []; } };
    const products = { 1: parse('[data-sv-gabriela-single]'), 2: parse('[data-sv-gabriela-double]'), 3: parse('[data-sv-gabriela-triple]') };
    const offers = [...bundle.querySelectorAll('[data-sv-offer]')];
    const addButton = bundle.querySelector('[data-sv-bundle-add]');
    const error = bundle.querySelector('[data-sv-bundle-error]');
    const prices = { 1: '34,90 €', 2: '54,90 €', 3: '79,90 €' };
    const labels = { 1: 'GABRIELA IN DEN WARENKORB', 2: '2ER GABRIELA-SET IN DEN WARENKORB', 3: '3ER GABRIELA-SET IN DEN WARENKORB' };
    const sizeOf = (variant) => (variant.options || []).find((value) => /^(XS|S|M|L|XL|XXL)$/i.test(value)) || variant.option1 || variant.title;
    offers.forEach((offer) => {
      const quantity = Number(offer.dataset.svOffer);
      const select = offer.querySelector('[data-sv-size]');
      const seen = new Set();
      (products[quantity] || []).forEach((variant) => { const size = sizeOf(variant); if (!seen.has(size)) { const option = document.createElement('option'); option.value = size; option.textContent = size + (variant.available ? '' : ' – ausverkauft'); option.disabled = !variant.available; select.appendChild(option); seen.add(size); } });
      offer.querySelector('input').addEventListener('change', () => setOffer(offer));
    });
    const setOffer = (offer) => { offers.forEach((entry) => entry.classList.toggle('is-selected', entry === offer)); const quantity = Number(offer.dataset.svOffer); addButton.textContent = labels[quantity] + ' · ' + prices[quantity]; error.textContent = ''; };
    const selectedVariant = (offer) => { const quantity = Number(offer.dataset.svOffer); const size = offer.querySelector('[data-sv-size]').value; return (products[quantity] || []).find((variant) => variant.available && sizeOf(variant) === size); };
    addButton.addEventListener('click', async () => {
      const offer = bundle.querySelector('[data-sv-offer].is-selected'); const variant = selectedVariant(offer);
      if (!variant) { error.textContent = 'Diese Größe ist für das gewählte Set aktuell nicht verfügbar.'; return; }
      addButton.disabled = true; addButton.textContent = 'WIRD HINZUGEFÜGT …';
      const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const requestBody = { items: [{ id: variant.id, quantity: 1, properties: { 'Set': offer.dataset.svOffer + '× Gabriela', 'Größenumtausch': 'Kostenlos innerhalb von 30 Tagen' } }] };
      try { const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(requestBody) }); const result = await response.json().catch(() => null); if (!response.ok) throw new Error(result && (result.description || result.message) || 'Das Set konnte nicht hinzugefügt werden.'); window.location.replace(root + 'cart?sv_added=' + Date.now()); } catch (requestError) { addButton.disabled = false; setOffer(offer); error.textContent = requestError.message || 'Bitte versuche es erneut.'; }
    });
    document.querySelectorAll('blockquote iframe, [class*="tiktok"] iframe').forEach((iframe) => iframe.setAttribute('loading', 'lazy'));
    setOffer(bundle.querySelector('[data-sv-offer="3"]'));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-care-decision"] && !Shopify.designMode) return;
  try {
    

function svInitCareSize() {
    const root = document.getElementById("sv-teresa-size-15610682016122");
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const overlay = root.querySelector('[data-overlay]');
    const dialog = root.querySelector('[role="dialog"]');
    const trigger = root.querySelector('[data-open]');
    const waistInput = root.querySelector('[data-waist]');
    const error = root.querySelector('[data-error]');
    const result = root.querySelector('[data-result]');
    const outOfRange = root.querySelector('[data-out-of-range]');
    const selectButton = root.querySelector('[data-select]');
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const sizes = [
      { name: 'XS', min: 60, max: 65, range: '60–65 cm' },
      { name: 'S', min: 66, max: 72, range: '66–72 cm' },
      { name: 'M', min: 73, max: 79, range: '73–79 cm' },
      { name: 'L', min: 80, max: 87, range: '80–87 cm' },
      { name: 'XL', min: 88, max: 96, range: '88–96 cm' },
      { name: '2XL', min: 97, max: 105, range: '97–105 cm' }
    ];
    let recommendedSize = null;
    let previousFocus = null;
    let previousOverflow = '';

    const sizeRadio = (size) => [...document.querySelectorAll('variant-selects input[type="radio"][name="Größe"]')].find((radio) => radio.value === size);
    const selectedColor = () => document.querySelector('variant-selects input[type="radio"][name="Farbe"]:checked')?.value || null;
    const matchingVariant = (size) => variants.find((variant) => variant.option1 === size && (!selectedColor() || variant.option2 === selectedColor()));

    function close() {
      overlay.hidden = true;
      document.body.style.overflow = previousOverflow;
      (previousFocus || trigger).focus();
    }

    trigger.addEventListener('click', () => {
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      dialog.focus();
    });
    root.querySelector('[data-close]').addEventListener('click', close);
    overlay.addEventListener('click', (event) => { if (event.target === overlay) close(); });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('button:not([disabled]), input, summary, a[href]')].filter((el) => !el.closest('[hidden]'));
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    root.querySelector('[data-form]').addEventListener('submit', (event) => {
      event.preventDefault();
      const value = Number(waistInput.value.replace(',', '.'));
      error.hidden = true;
      result.hidden = true;
      outOfRange.hidden = true;
      recommendedSize = null;
      if (!waistInput.value || !Number.isFinite(value) || value < 40 || value > 140) {
        error.textContent = 'Bitte gib einen gültigen Taillenumfang in cm ein.';
        error.hidden = false;
        waistInput.focus();
        return;
      }
      if (value < 60 || value > 105) { outOfRange.hidden = false; return; }
      const match = sizes.find((size) => value <= size.max);
      recommendedSize = match.name;
      root.querySelector('[data-size]').textContent = match.name;
      const previousSize = sizes[sizes.indexOf(match) - 1];
      root.querySelector('[data-range]').textContent = value < match.min && previousSize
        ? value.toLocaleString('de-DE') + ' cm liegen zwischen ' + previousSize.name + ' und ' + match.name + '. Für mehr Komfort empfehlen wir ' + match.name + '.'
        : 'Größenbereich laut Tabelle: ' + match.range;
      root.querySelector('.sv-teresa-size__hint').hidden = value < match.min;
      selectButton.textContent = 'Größe ' + match.name + ' merken';
      const variant = matchingVariant(match.name);
      const available = !!variant?.available;
      selectButton.disabled = !available;
      const availability = root.querySelector('[data-availability]');
      availability.hidden = !!available;
      availability.textContent = variant ? 'Diese Größe ist in deiner gewählten Farbe gerade nicht verfügbar. Wähle eine andere Farbe auf der Produktseite.' : 'Diese Größe ist aktuell nicht auswählbar. Bitte kontaktiere uns.';
      result.hidden = false;
    });

    selectButton.addEventListener('click', () => {
      if (!recommendedSize) return;
      const variant = matchingVariant(recommendedSize);
      if (!variant?.available) return;
      const recap = document.querySelector('[data-size-recap]');
      recap.textContent = 'Deine Größenempfehlung: ' + recommendedSize + '. Farbe und Verfügbarkeit wählst du auf der Produktseite.';
      const link = document.querySelector('[data-shop-link]');
      link.href = link.href.split('?')[0] + '?variant=' + variant.id;
      close();
    });
}
svInitCareSize();
document.addEventListener('shopify:section:load', svInitCareSize);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-care-page-decision"] && !Shopify.designMode) return;
  try {
    

function svInitCareSize() {
    const root = document.getElementById("sv-teresa-size-15610682016122");
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const overlay = root.querySelector('[data-overlay]');
    const dialog = root.querySelector('[role="dialog"]');
    const trigger = root.querySelector('[data-open]');
    const waistInput = root.querySelector('[data-waist]');
    const error = root.querySelector('[data-error]');
    const result = root.querySelector('[data-result]');
    const outOfRange = root.querySelector('[data-out-of-range]');
    const selectButton = root.querySelector('[data-select]');
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const copy = JSON.parse(root.querySelector('[data-size-i18n]').textContent);
    const formatCopy = (key, values = {}) => Object.entries(values).reduce((text, [token, value]) => text.replaceAll('__' + token.toUpperCase() + '__', String(value)), copy[key]);
    const sizes = [
      { name: 'XS', min: 60, max: 65, range: '60–65 cm' },
      { name: 'S', min: 66, max: 72, range: '66–72 cm' },
      { name: 'M', min: 73, max: 79, range: '73–79 cm' },
      { name: 'L', min: 80, max: 87, range: '80–87 cm' },
      { name: 'XL', min: 88, max: 96, range: '88–96 cm' },
      { name: '2XL', min: 97, max: 105, range: '97–105 cm' }
    ];
    let recommendedSize = null;
    let previousFocus = null;
    let previousOverflow = '';

    const sizeRadio = (size) => [...document.querySelectorAll('variant-selects input[type="radio"][name="Größe"]')].find((radio) => radio.value === size);
    const selectedColor = () => document.querySelector('variant-selects input[type="radio"][name="Farbe"]:checked')?.value || null;
    const matchingVariant = (size) => variants.find((variant) => variant.option1 === size && (!selectedColor() || variant.option2 === selectedColor()));

    function close() {
      overlay.hidden = true;
      document.body.style.overflow = previousOverflow;
      (previousFocus || trigger).focus();
    }

    trigger.addEventListener('click', () => {
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      dialog.focus();
    });
    root.querySelector('[data-close]').addEventListener('click', close);
    overlay.addEventListener('click', (event) => { if (event.target === overlay) close(); });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('button:not([disabled]), input, summary, a[href]')].filter((el) => !el.closest('[hidden]'));
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    root.querySelector('[data-form]').addEventListener('submit', (event) => {
      event.preventDefault();
      const value = Number(waistInput.value.replace(',', '.'));
      error.hidden = true;
      result.hidden = true;
      outOfRange.hidden = true;
      recommendedSize = null;
      if (!waistInput.value || !Number.isFinite(value) || value < 40 || value > 140) {
        error.textContent = copy.invalid;
        error.hidden = false;
        waistInput.focus();
        return;
      }
      if (value < 60 || value > 105) { outOfRange.hidden = false; return; }
      const match = sizes.find((size) => value <= size.max);
      recommendedSize = match.name;
      root.querySelector('[data-size]').textContent = match.name;
      const previousSize = sizes[sizes.indexOf(match) - 1];
      root.querySelector('[data-range]').textContent = value < match.min && previousSize
        ? formatCopy('between', {value: value.toLocaleString(root.dataset.locale || 'de'), previous: previousSize.name, size: match.name})
        : formatCopy('size_range', {range: match.range});
      root.querySelector('.sv-teresa-size__hint').hidden = value < match.min;
      selectButton.textContent = formatCopy('remember', {size: match.name});
      const variant = matchingVariant(match.name);
      const available = !!variant?.available;
      selectButton.disabled = !available;
      const availability = root.querySelector('[data-availability]');
      availability.hidden = !!available;
      availability.textContent = variant ? copy.unavailable_color : copy.unavailable_size;
      result.hidden = false;
    });

    selectButton.addEventListener('click', () => {
      if (!recommendedSize) return;
      const variant = matchingVariant(recommendedSize);
      if (!variant?.available) return;
      const recap = document.querySelector('[data-size-recap]');
      recap.textContent = formatCopy('recap', {size: recommendedSize});
      const link = document.querySelector('[data-shop-link]');
      link.href = link.href.split('?')[0] + '?variant=' + variant.id;
      close();
    });
}
svInitCareSize();
document.addEventListener('shopify:section:load', svInitCareSize);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-faja11"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const closeNewsletter = () => document.querySelectorAll('[data-kl-scroll-locking-modal="true"] .klaviyo-close-form').forEach(button => button.click());
    const newsletterObserver = new MutationObserver(closeNewsletter);
    newsletterObserver.observe(document.body, { childList: true, subtree: true });
    closeNewsletter();
    const products = JSON.parse(root.querySelector('[data-product-data]').textContent);
    const text = JSON.parse(root.querySelector('[data-text-data]').textContent);
    const form = root.querySelector('[data-pair-form]');
    if (!form || !products.length) return;
    const money = new Intl.NumberFormat(root.dataset.locale || 'de', { style: 'currency', currency: root.dataset.currency || 'EUR' });
    const format = value => money.format(value / 100);
    const error = root.querySelector('[data-error]');
    const submit = root.querySelector('[data-submit]');
    const ctaHTML = submit.innerHTML;
    const pickers = Array.from(root.querySelectorAll('[data-picker]'));
    let added = false;
    const states = pickers.map(() => ({ product: products[0], values: [], variant: null }));
    function updateSummary() {
      const prices = states.map(s => s.variant ? s.variant.price : s.product.price);
      const full = prices[0] + prices[1];
      const saving = Math.min(...prices);
      root.querySelector('[data-original]').textContent = format(full);
      root.querySelector('[data-total]').textContent = format(full - saving);
      root.querySelector('[data-saving]').textContent = `${text.saving} ${format(saving)}`;
      submit.disabled = states.some(s => !s.variant || !s.variant.available);
    }
    function updatePicker(index) {
      const state = states[index];
      const picker = pickers[index];
      state.values = Array.from(picker.querySelectorAll('[data-option]')).map(s => s.value);
      state.variant = state.product.variants.find(v => v.options.every((value, i) => value === state.values[i])) || null;
      picker.querySelectorAll('[data-option]').forEach((select, optionIndex) => {
        Array.from(select.options).forEach(option => {
          if (!option.value) return;
          option.disabled = !state.product.variants.some(v => v.available && v.options[optionIndex] === option.value && v.options.every((value, i) => i === optionIndex || !state.values[i] || value === state.values[i]));
        });
      });
      picker.querySelector('[data-picker-status]').textContent = state.variant ? (state.variant.available ? text.ready : text.unavailable) : text.choose;
      const image = picker.querySelector('[data-picker-image]');
      const variantImage = state.variant && state.variant.featured_image;
      image.src = variantImage && variantImage.src ? variantImage.src : state.product.featured_image;
      image.alt = state.product.title;
      updateSummary();
    }
    function setProduct(index, id) {
      const state = states[index];
      state.product = products.find(p => String(p.id) === String(id)) || products[0];
      pickers[index].querySelector('[data-model]').value = String(state.product.id);
      const options = pickers[index].querySelector('[data-options]');
      options.replaceChildren();
      const firstAvailable = state.product.variants.find(v => v.available);
      state.product.options.forEach((option, optionIndex) => {
        const name = typeof option === 'string' ? option : option.name;
        const group = document.createElement('div');
        const label = document.createElement('label');
        const select = document.createElement('select');
        select.id = `sv11-${root.closest('.shopify-section')?.id || 'pair'}-${index}-${optionIndex}`;
        label.htmlFor = select.id;
        label.className = 'form__label';
        select.className = 'select__select';
        label.textContent = name;
        select.dataset.option = String(optionIndex);
        select.required = true;
        select.add(new Option('—', ''));
        [...new Set(state.product.variants.map(v => v.options[optionIndex]))].forEach(value => select.add(new Option(value, value)));
        if (!/gr[oö]ße|size/i.test(name) && firstAvailable) select.value = firstAvailable.options[optionIndex];
        select.addEventListener('change', () => { error.hidden = true; updatePicker(index); });
        group.append(label, select);
        options.append(group);
      });
      updatePicker(index);
    }
    pickers.forEach((picker, index) => {
      picker.querySelector('[data-model]').addEventListener('change', event => setProduct(index, event.target.value));
      setProduct(index, products[0].id);
    });
    root.querySelectorAll('[data-pick-model]').forEach(button => button.addEventListener('click', () => {
      setProduct(0, button.dataset.pickModel);
      form.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      pickers[0].querySelector('[data-option]').focus({ preventScroll: true });
    }));
    if (new URLSearchParams(window.location.search).get('model') === 'faja-teresa') setProduct(0, products.find(p => p.handle === 'faja-teresa')?.id || products[0].id);
    async function post(path, payload) {
      const response = await fetch(root.dataset.root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || text.error);
      return data;
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (form.getAttribute('aria-busy') === 'true' || states.some(s => !s.variant || !s.variant.available)) return;
      error.hidden = true;
      form.setAttribute('aria-busy', 'true');
      submit.disabled = true;
      submit.textContent = text.loading;
      try {
        if (!added) {
          const ids = states.map(s => s.variant.id);
          const items = ids[0] === ids[1] ? [{ id: ids[0], quantity: 2 }] : ids.map(id => ({ id, quantity: 1 }));
          await post('cart/add.js', { items });
          added = true;
          pickers.forEach(picker => picker.querySelectorAll('select').forEach(select => { select.disabled = true; }));
        }
        const cart = await post('cart/update.js', { discount: root.dataset.code });
        const applied = (cart.discount_codes || []).some(code => code.code.toUpperCase() === root.dataset.code.toUpperCase() && code.applicable);
        const allocated = (cart.cart_level_discount_applications || []).concat((cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(a => a.discount_application))).some(a => String(a.title).toUpperCase() === root.dataset.code.toUpperCase());
        if (!applied && !allocated) throw new Error(text.discount_error);
        const destination = new URL(root.dataset.root + 'cart', window.location.origin);
        const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (previewTheme) destination.searchParams.set('preview_theme_id', previewTheme);
        window.location.assign(destination.href);
      } catch (failure) {
        error.textContent = failure.message || text.error;
        error.hidden = false;
        form.setAttribute('aria-busy', 'false');
        submit.innerHTML = added ? text.retry : ctaHTML;
        updateSummary();
      }
    });
  }
  document.querySelectorAll('[data-sv11]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-sv11]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teresa-conversion"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const bundle = document.querySelector('[data-sv-teresa-bundle]');
      const page = document.querySelector('[data-sv-teresa-page]');
      if (!bundle || !page || bundle.dataset.ready === 'true') return;
      bundle.dataset.ready = 'true';
      const variantData = page.parentElement.querySelector('[data-sv-teresa-variants]');
      const variants = variantData ? JSON.parse(variantData.textContent) : [];
      const offers = [...bundle.querySelectorAll('[data-sv-offer]')];
      const addButton = bundle.querySelector('[data-sv-bundle-add]');
      const error = bundle.querySelector('[data-sv-bundle-error]');
      const setOffer = (offer) => {
        offers.forEach((entry) => entry.classList.toggle('is-selected', entry === offer));
        const quantity = Number(offer.dataset.svOffer);
        addButton.disabled = false;
        addButton.textContent = quantity === 2 ? 'TERESA-SET IN DEN WARENKORB · 79,90 €' : 'TERESA IN DEN WARENKORB · 49,90 €';
        error.textContent = '';
      };
      offers.forEach((offer) => {
        offer.querySelector('input[type="radio"]').addEventListener('change', () => setOffer(offer));
      });

      const selectedVariant = (item) => {
        const values = [...item.querySelectorAll('select')].sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((select) => select.value);
        return variants.find((variant) => variant.available && variant.options.every((value, index) => value === values[index]));
      };

      const resetAddButton = () => {
        const offer = bundle.querySelector('[data-sv-offer].is-selected');
        if (!offer) {
          addButton.disabled = true;
          addButton.textContent = 'WÄHLE DEIN TERESA-SET';
          return;
        }
        addButton.disabled = false;
        setOffer(offer);
      };

      window.addEventListener('pageshow', resetAddButton);

      addButton.addEventListener('click', async () => {
        const offer = bundle.querySelector('[data-sv-offer].is-selected');
        if (!offer) {
          error.textContent = 'Bitte wähle zuerst eine Teresa-Option aus.';
          return;
        }
        const items = [...offer.querySelectorAll('[data-sv-item]')].map(selectedVariant);
        if (items.some((variant) => !variant)) {
          error.textContent = 'Eine gewählte Kombination ist aktuell nicht verfügbar.';
          return;
        }
        error.textContent = '';
        addButton.disabled = true;
        addButton.textContent = 'WIRD HINZUGEFÜGT …';
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const quantities = new Map();
        items.forEach((variant) => quantities.set(variant.id, (quantities.get(variant.id) || 0) + 1));
        const cartItems = [...quantities].map(([id, quantity]) => ({
          id,
          quantity,
          properties: { 'Größenumtausch': 'Kostenlos innerhalb von 30 Tagen' },
        }));
        const cartDrawer = document.querySelector('cart-drawer');
        const requestBody = { items: cartItems };
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          requestBody.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
          requestBody.sections_url = window.location.pathname;
        }

        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify(requestBody)
          });
          const result = await response.json().catch(() => null);
          if (!response.ok) {
            const message = result && (result.description || result.message);
            throw new Error(message || 'Das Set konnte nicht hinzugefügt werden.');
          }
          if (cartDrawer && typeof cartDrawer.renderContents === 'function' && result && result.sections) {
            cartDrawer.renderContents(result);
            resetAddButton();
            return;
          }
          window.location.assign(`${root}cart`);
        } catch (requestError) {
          resetAddButton();
          error.textContent = requestError.message || 'Das Set konnte gerade nicht hinzugefügt werden. Bitte versuche es erneut.';
        }
      });

      page.querySelectorAll('[data-sv-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          page.querySelectorAll('[data-sv-tab]').forEach((entry) => entry.setAttribute('aria-selected', String(entry === tab)));
          page.querySelectorAll('[data-sv-panel]').forEach((panel) => {
            const active = panel.dataset.svPanel === tab.dataset.svTab;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
          });
        });
      });
    })();

  } catch(e) { console.error(e); }
})();
})();
